import { FiltersMap } from '@wix/bex-core';
import { ToolbarCollectionState } from '../../state';
import React, { ReactNode, useEffect, useState } from 'react';
import { ToolbarState } from './ToolbarState';
import { usePageScrollContext } from '@wix/design-system';

export function ToolbarAndTitlebarContainer<T, F extends FiltersMap>({
  state,
  children,
}: {
  state: ToolbarCollectionState<T, F>;
  children?: ReactNode;
}) {
  const { scrollableContentRef: scrollablePageRef } = usePageScrollContext();

  const [toolbarState] = useState(() => new ToolbarState(state));

  useEffect(() => {
    return toolbarState.init({
      scrollElement: scrollablePageRef?.current,
    });
  }, []);

  return (
    <div
      data-hook="toolbar-and-titlebar-container"
      ref={(el) => {
        toolbarState.toolbar.toolbarRect.element = el;
      }}
    >
      {children}
    </div>
  );
}
